// ReconsentDialog.tsx — the research consent page, re-presented from Settings.
//
// Turning research back ON must NOT be a silent toggle: we re-show the same
// informed-consent page from onboarding and only record consent if the person
// confirms here. (UK GDPR: research/wellbeing data needs explicit, demonstrable,
// informed consent that can be given freshly each time it is turned on.)
// Closing or "Not just now" leaves research OFF.
import { Wordmark, Icon } from '@/components/icons';
import { ResearchConsentStep } from '@/flows/onboarding/ResearchConsentStep';

export function ReconsentDialog({
  onDecide,
  onClose,
  saving = false,
}: {
  /** granted = confirmed consent; declined = "Not just now". Either way the caller closes. */
  onDecide: (granted: boolean) => void;
  onClose: () => void;
  saving?: boolean;
}) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 130,
        background: 'var(--cream)',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        animation: 'rise .4s cubic-bezier(.2,.7,.3,1)',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: 520,
          margin: '0 auto',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: 'calc(20px + var(--safe-top)) 26px calc(30px + var(--safe-bottom))',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ alignSelf: 'flex-start' }}><Wordmark h={20} /></div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            disabled={saving}
            style={{
              minWidth: 40, minHeight: 40, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-soft)',
            }}
          >
            <Icon name="chevDown" size={22} />
          </button>
        </div>
        <ResearchConsentStep onDecide={onDecide} saving={saving} />
      </div>
    </div>
  );
}
